<template>
	<div class="pos-container" :class="{hideMobile: !noHideMobile}">
		<div class="row no-wrap">
			<div class="pos-header" :class="{tapPhone: currentPos && ['tap_phone', 'bluetooth', 'handoff'].includes(currentPos.terminal_id)}">
				<div class="physical-pos-select-container">
					<AppChevronIcon class="button-arrow" v-show="terminals.length > 1" direction="left" @click="previousPos()" />
					<div class="current-pos-name">{{ currentPos ? currentPos.name : "---" }}</div>
					<AppChevronIcon class="button-arrow" v-show="terminals.length > 1" direction="right" @click="nextPos()" />
				</div>
			</div>
			<div class="title-icon-btn">
				<AppButtonIcon :active="activeTxs" prevent-change @click-icon="$emit('toggle-transactions-sheet')" icon-name="icon-list-transactions"/>
			</div>
		</div>
		<div class="pos-display-container">
			<div class="pos-display">
				<p class="pos-display-text">{{ currentValueFormatted }}</p>
				<p class="pos-display-currency">€</p>
			</div>
		</div>
		<div class="pos-keypad-container">
			<div class="pos-keypad">
				<div class="pos-keypad-row">
					<div class="pos-keypad-button" @click="addNumber(1)"><div class="pos-keypad-button-inner">1</div></div>
					<div class="pos-keypad-button" @click="addNumber(2)"><div class="pos-keypad-button-inner">2</div></div>
					<div class="pos-keypad-button" @click="addNumber(3)"><div class="pos-keypad-button-inner">3</div></div>
				</div>
				<div class="pos-keypad-row">
					<div class="pos-keypad-button" @click="addNumber(4)"><div class="pos-keypad-button-inner">4</div></div>
					<div class="pos-keypad-button" @click="addNumber(5)"><div class="pos-keypad-button-inner">5</div></div>
					<div class="pos-keypad-button" @click="addNumber(6)"><div class="pos-keypad-button-inner">6</div></div>
				</div>
				<div class="pos-keypad-row">
					<div class="pos-keypad-button" @click="addNumber(7)"><div class="pos-keypad-button-inner">7</div></div>
					<div class="pos-keypad-button" @click="addNumber(8)"><div class="pos-keypad-button-inner">8</div></div>
					<div class="pos-keypad-button" @click="addNumber(9)"><div class="pos-keypad-button-inner">9</div></div>
				</div>
				<div class="pos-keypad-row">
					<div class="pos-keypad-button pos-keypad-button-empty"></div>
					<div class="pos-keypad-button" @click="addNumber(0)"><div class="pos-keypad-button-inner">0</div></div>
					<div class="pos-keypad-button" @click="addDoubleZero()"><div class="pos-keypad-button-inner">00</div></div>
				</div>
			</div>
		</div>
		<div class="pos-actions">
			<div class="pos-action pink" @click="cancel()"><div class="pos-action-inner pos-action-reset" v-html="getIcon('iconReset')"></div></div>
			<div class="pos-action yellow" @click="backspace()"><div class="pos-action-inner pos-action-backspace" v-html="getIcon('iconBackspace')"></div></div>
			<div class="pos-action green" :class="{notactive: currentValue <= 50}" @click="send()"><div class="pos-action-inner pos-action-send" v-html="getIcon('iconSend')"></div></div>
		</div>
		<AppNotification ref="notification" :type="-2" :title="getString('error')" :body-text="getString('no_terminal_selected')"/>
	</div>
</template>

<script>
import AppButtonIcon from "@/shared/components/AppButtonIcon.vue";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import AppNotification from "@/shared/components/AppNotification.vue";
import {useSvgStore, useLanguageStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";

export default {
	setup() {
		let svgStore = useSvgStore();
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		return {
			getIcon: svgStore.get,
			getString: languageStore.getString,
			userStore
		}
	},
	name: "PhysicalPos",
	components: {AppNotification, AppButtonIcon, AppChevronIcon},
	emits: ['send-payment', "changed-terminal", "toggle-transactions-sheet"],
	props: {
		activeTxs: {
			type: Boolean,
			default: false
		},
		noHideMobile: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			currentValue: 0,
			terminalId: null,
			terminals: [],
			maxValue: 100000000,
		}
	},
	computed: {
		currentValueFormatted() {
			return (this.currentValue / 100).toFixed(2).replace(".", ",");
		},
		currentPos() {
			return this.terminals.find(t => t.terminal_id === this.terminalId);
		}
	},
	methods: {
		addNumber(number) {
			this.currentValue = this.currentValue * 10 + number;
			if (this.currentValue > this.maxValue) {
				this.currentValue = this.maxValue;
			}
		},
		addDoubleZero() {
			this.currentValue = this.currentValue * 100;
			if (this.currentValue > this.maxValue) {
				this.currentValue = this.maxValue;
			}
		},
		cancel() {
			this.currentValue = 0;
		},
		backspace() {
			this.currentValue = Math.floor(this.currentValue / 10);
		},
		send() {
			if(this.terminalId) {
				this.$emit('send-payment', this.currentValue, this.terminalId, null);
				this.currentValue = 0;
			} else {
				this.$refs.notification.openNotification();
			}
		},
		selectDefaultTerminal() {
			if (this.terminals.length > 0) {
				let lastTerminalId = localStorage.getItem("lastTerminalId");
				if(lastTerminalId && this.terminals.find(t => t.terminal_id === lastTerminalId)) {
					this.terminalId = lastTerminalId;
				} else {
					this.terminalId = this.terminals[0].terminal_id;
				}
				localStorage.setItem("lastTerminalId", this.terminalId);
			} else {
				this.terminalId = null;
			}
			this.$emit("changed-terminal", this.terminalId);
		},
		previousPos() {
			let index = this.terminals.findIndex(t => t.terminal_id === this.terminalId);
			if (index > 0) {
				this.terminalId = this.terminals[index - 1].terminal_id;
			} else {
				this.terminalId = this.terminals[this.terminals.length - 1].terminal_id;
			}
			localStorage.setItem("lastTerminalId", this.terminalId);
			this.$emit("changed-terminal", this.terminalId);
		},
		nextPos() {
			let index = this.terminals.findIndex(t => t.terminal_id === this.terminalId);
			if (index < this.terminals.length - 1) {
				this.terminalId = this.terminals[index + 1].terminal_id;
			} else {
				this.terminalId = this.terminals[0].terminal_id;
			}
			localStorage.setItem("lastTerminalId", this.terminalId);
			this.$emit("changed-terminal", this.terminalId);
		},
	},
	created() {
		this.userStore.getBusinessTerminals(true, (terminals) => {
			this.terminals = terminals;
			this.selectDefaultTerminal();
		});
	},
	watch: {
		"userStore.currBusinessId": function (newVal, oldVal) {
			if(newVal != null && newVal !== oldVal) {
				this.userStore.getBusinessTerminals(true, (terminals) => {
					this.terminals = terminals;
					if(this.terminalId == null) {
						this.selectDefaultTerminal();
					}
				});
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.pos-container {
	background-color: rgb(222,229,241);
	padding: 20px;
	position: relative;
	border-radius: 30px;

	.no-wrap {
		flex-wrap: nowrap;
		align-items: flex-start;
	}

	&:before {
		content: "";
		display: block;
		position: absolute;
		top: -12px;
		left: -12px;
		width: 100%;
		height: 100%;
		background-color: #4B4B4B;
		border: 12px solid #4B4B4B;
		z-index: -1;
		border-radius: 39px;
	}

	&:after {
		content: "";
		display: block;
		position: absolute;
		top: -8px;
		left: -8px;
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0);
		border: 8px solid rgb(0,0,0);
		z-index: -1;
		border-radius: 36px;
	}

	.pos-header {
		background-color: #ADBFDC;
		margin-bottom: 25px;
		box-shadow: inset 2px 1px 7px #2352A24D;
		color: $primary;
		border-radius: 13px;
		width: calc(100% - 40px);

		.physical-pos-select-container {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 8px 15px;

			.button-arrow {
				cursor: pointer;
				padding: 3px;
				box-sizing: content-box;
			}

			.current-pos-name {
				max-width: 160px;
				margin: 0 auto;
				font-weight: 500;
				@include truncateString();
			}
		}

		&.tapPhone {
			background-color: #2CECBE;
		}

	}
	.title-icon-btn {
		@include centered;
		justify-content: flex-end;
		width: 40px;
		margin-bottom: 25px;
	}

	.pos-display-container {
		background-color: #102446;
		margin-bottom: 25px;
		border-radius: 13px;
		padding: 45px 12px 22px;
		box-shadow: -4px -4px 8px rgba(255, 255, 255, 0.9), 4px 4px 8px #2352A24D;

		.pos-display {
			display: flex;
			justify-content: flex-end;

			.pos-display-text {
				font-family: "calculatorFont", monospace;
			}

			.pos-display-currency {
				margin-left: 10px;
				font-size: 30px;
				line-height: 22px;
			}
		}

		p {
			color: $secondary;
			font-size: 50px;
		}
	}

	.pos-keypad-container {

		.pos-keypad {

			.pos-keypad-row {
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				margin-bottom: 10px;

				.pos-keypad-button {
					background-color: #2352A2;
					color: white;
					border-radius: 26px;
					width: 80px;
					height: 80px;
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;

					.pos-keypad-button-inner {
						background-color: #2352A2;
						border-radius: 20px;
						box-shadow: -3px -3px 6px rgba(255, 255, 255, 0.25), inset 3px 3px 6px rgba(0, 0, 0, 0), 3px 3px 6px rgba(0, 0, 0, 0.25), inset -3px -3px 6px rgba(255, 255, 255, 0);
						font-size: 40px;
						display: flex;
						justify-content: center;
						align-items: center;
						width: 70%;
						height: 70%;
						transition: box-shadow 0.1s ease-in-out;
						@include noSelect();
					}

					&.pos-keypad-button-empty {
						opacity: 0.4;
						cursor: default;
					}

					&:active .pos-keypad-button-inner {
						box-shadow: -3px -3px 6px rgba(255, 255, 255, 0), inset 3px 3px 6px rgba(0, 0, 0, 0.25), 3px 3px 6px rgba(0, 0, 0, 0), inset -3px -3px 6px rgba(255, 255, 255, 0.25);
					}
				}

				.pos-keypad-button:first-child {
					margin-right: 13px;
				}

				.pos-keypad-button:last-child {
					margin-left: 13px;
				}

			}

		}
	}

	.pos-actions {
		display: flex;
		flex-direction: row;
		justify-content: space-between;

		.pos-action {
			background-color: #2352A2;
			color: white;
			border-radius: 40px;
			width: 80px;
			height: 80px;
			display: flex;
			justify-content: center;
			align-items: center;
			cursor: pointer;

			.pos-action-inner {
				background-color: #2352A2;
				border-radius: 40px;
				box-shadow: -3px -3px 6px rgba(255, 255, 255, 0.25), inset 3px 3px 6px rgba(0, 0, 0, 0), 3px 3px 6px rgba(0, 0, 0, 0.25), inset -3px -3px 6px rgba(255, 255, 255, 0);
				font-size: 40px;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 70%;
				height: 70%;
				transition: box-shadow 0.1s ease-in-out;
				@include noSelect();

				&.pos-action-send :deep(svg) {
					width: 55%;
					height: 55%;

					.stroke {
						stroke: $primary;
					}
				}

				&.pos-action-backspace :deep(svg) {
					width: 55%;
					height: 55%;
					margin-right: 2px;

					.stroke {
						stroke: white;
					}
				}

				&.pos-action-reset :deep(svg) {
					width: 55%;
					height: 55%;

					.fill {
						fill: white;
					}
				}
			}

			&:active .pos-action-inner {
				box-shadow: -3px -3px 6px rgba(255, 255, 255, 0), inset 3px 3px 6px rgba(0, 0, 0, 0.25), 3px 3px 6px rgba(0, 0, 0, 0), inset -3px -3px 6px rgba(255, 255, 255, 0.25);
			}

			&.pos-action-inner-empty {
				opacity: 0.4;
				cursor: default;
			}

			&.yellow {
				background-color: #FDC700;
				color: white;

				.pos-action-inner {
					background-color: #FDC700;
				}
			}

			&.pink {
				background-color: #FC2291;

				.pos-action-inner {
					background-color: #FC2291;
				}
			}

			&.green {
				background-color: $secondary;
				color: $primary;

				.pos-action-inner {
					background-color: $secondary;
				}
			}


			&.notactive {
				background-color: #ADBFDC;
				cursor: default;
				pointer-events: none;

				.pos-action-inner {
					background-color: #ADBFDC;
					box-shadow: -3px -3px 6px rgba(255, 255, 255, 0), inset -3px -3px 6px rgba(255, 255, 255, 0), 3px 3px 6px rgba(0, 0, 0, 0), inset 3px 3px 6px rgba(0, 0, 0, 0);
				}

				:deep(svg) {

					.fill {
						fill: $primary;
					}

					.stroke {
						stroke: $primary;
					}
				}
			}

		}

		.pos-action:first-child {
			margin-right: 13px;
		}

		.pos-action:last-child {
			margin-left: 13px;
		}
	}


	@media (max-width: 400px) {

		&.hideMobile {
			border-radius: 0;
			padding: 20px 65px;

			&:before {
				display: none;
			}

			&:after {
				display: none;
			}

		}

		.pos-header {
			margin-bottom: 10px;

			.physical-pos-select-container {
				padding: 8px 15px;
			}

		}
		.title-icon-btn {
			margin-bottom: 10px;
		}

		.pos-display-container {
			margin-bottom: 15px;
			padding: 35px 12px 15px;

			p {
				font-size: 45px;
			}

			.pos-display {
				.pos-display-currency {
					font-size: 26px;
					line-height: 26px;
				}
			}
		}

		.pos-keypad-container {

			.pos-keypad {
				.pos-keypad-row {
					.pos-keypad-button {
						width: 70px;
						height: 70px;

						.pos-keypad-button-inner {
							font-size: 34px;
						}
					}
				}
			}
		}

		.pos-actions {
			.pos-action {
				width: 70px;
				height: 70px;

				.pos-action-inner {
					font-size: 34px;
				}
			}
		}
	}

	@media (max-width: 370px) {
		&.hideMobile {
			padding: 20px 45px;
		}
	}

	@media (max-width: 330px) {
		&.hideMobile {
			padding: 20px;
		}
	}
}
</style>